// source: witbooking/backoffice/b2b/v1/b2b_admin_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.witbooking.backoffice.b2b.v1.AdminEntity', null, global);
goog.exportSymbol('proto.witbooking.backoffice.b2b.v1.CommercialTermsRow', null, global);
goog.exportSymbol('proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey', null, global);
goog.exportSymbol('proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest.displayName = 'proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.displayName = 'proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.b2b.v1.AdminEntity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.b2b.v1.AdminEntity.displayName = 'proto.witbooking.backoffice.b2b.v1.AdminEntity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest.displayName = 'proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.displayName = 'proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.b2b.v1.CommercialTermsRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.displayName = 'proto.witbooking.backoffice.b2b.v1.CommercialTermsRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.displayName = 'proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.displayName = 'proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse.displayName = 'proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest.displayName = 'proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse.displayName = 'proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest}
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest;
  return proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest}
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    entitiesList: jspb.Message.toObjectList(msg.getEntitiesList(),
    proto.witbooking.backoffice.b2b.v1.AdminEntity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse}
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse;
  return proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse}
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.b2b.v1.AdminEntity;
      reader.readMessage(value,proto.witbooking.backoffice.b2b.v1.AdminEntity.deserializeBinaryFromReader);
      msg.addEntities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.b2b.v1.AdminEntity.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AdminEntity entities = 1;
 * @return {!Array<!proto.witbooking.backoffice.b2b.v1.AdminEntity>}
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.prototype.getEntitiesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.b2b.v1.AdminEntity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.b2b.v1.AdminEntity, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.b2b.v1.AdminEntity>} value
 * @return {!proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse} returns this
*/
proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.prototype.setEntitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.b2b.v1.AdminEntity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.b2b.v1.AdminEntity}
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.prototype.addEntities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.b2b.v1.AdminEntity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse} returns this
 */
proto.witbooking.backoffice.b2b.v1.ListEntitiesResponse.prototype.clearEntitiesList = function() {
  return this.setEntitiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.b2b.v1.AdminEntity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.b2b.v1.AdminEntity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.toObject = function(includeInstance, msg) {
  var f, obj = {
    entityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    externalId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    entityType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    legalName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    credit: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    status: jspb.Message.getFieldWithDefault(msg, 6, ""),
    parentExternalId: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.b2b.v1.AdminEntity}
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.b2b.v1.AdminEntity;
  return proto.witbooking.backoffice.b2b.v1.AdminEntity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.b2b.v1.AdminEntity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.b2b.v1.AdminEntity}
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntityType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegalName(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCredit(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentExternalId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.b2b.v1.AdminEntity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.b2b.v1.AdminEntity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExternalId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEntityType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLegalName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCredit();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getParentExternalId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string entity_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.prototype.getEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.AdminEntity} returns this
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.prototype.setEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string external_id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.prototype.getExternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.AdminEntity} returns this
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.prototype.setExternalId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string entity_type = 3;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.prototype.getEntityType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.AdminEntity} returns this
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.prototype.setEntityType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string legal_name = 4;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.prototype.getLegalName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.AdminEntity} returns this
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.prototype.setLegalName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool credit = 5;
 * @return {boolean}
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.prototype.getCredit = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.b2b.v1.AdminEntity} returns this
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.prototype.setCredit = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string status = 6;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.AdminEntity} returns this
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string parent_external_id = 7;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.prototype.getParentExternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.AdminEntity} returns this
 */
proto.witbooking.backoffice.b2b.v1.AdminEntity.prototype.setParentExternalId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    page: jspb.Message.getFieldWithDefault(msg, 1, 0),
    size: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest}
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest;
  return proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest}
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest} returns this
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 size = 2;
 * @return {number}
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest} returns this
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsRequest.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    rowsList: jspb.Message.toObjectList(msg.getRowsList(),
    proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse}
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse;
  return proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse}
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.b2b.v1.CommercialTermsRow;
      reader.readMessage(value,proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.deserializeBinaryFromReader);
      msg.addRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CommercialTermsRow rows = 1;
 * @return {!Array<!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow>}
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.prototype.getRowsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.b2b.v1.CommercialTermsRow, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow>} value
 * @return {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse} returns this
*/
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.prototype.setRowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow}
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.prototype.addRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.b2b.v1.CommercialTermsRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse} returns this
 */
proto.witbooking.backoffice.b2b.v1.ListCommercialTermsResponse.prototype.clearRowsList = function() {
  return this.setRowsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.toObject = function(includeInstance, msg) {
  var f, obj = {
    entityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    entityName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    agreementId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    lineId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    counterpartyName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    commissionPct: jspb.Message.getFieldWithDefault(msg, 6, ""),
    net: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    validFrom: jspb.Message.getFieldWithDefault(msg, 8, ""),
    validTo: jspb.Message.getFieldWithDefault(msg, 9, ""),
    hotelCodesList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    kind: jspb.Message.getFieldWithDefault(msg, 11, ""),
    appliesTo: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.b2b.v1.CommercialTermsRow;
  return proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntityName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgreementId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLineId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCounterpartyName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommissionPct(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNet(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidFrom(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidTo(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addHotelCodes(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setKind(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppliesTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEntityName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAgreementId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLineId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCounterpartyName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCommissionPct();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getNet();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getValidFrom();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getValidTo();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getHotelCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getKind();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAppliesTo();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional string entity_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.getEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.setEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string entity_name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.getEntityName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.setEntityName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string agreement_id = 3;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.getAgreementId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.setAgreementId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string line_id = 4;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.getLineId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.setLineId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string counterparty_name = 5;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.getCounterpartyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.setCounterpartyName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string commission_pct = 6;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.getCommissionPct = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.setCommissionPct = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool net = 7;
 * @return {boolean}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.getNet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.setNet = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string valid_from = 8;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.getValidFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.setValidFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string valid_to = 9;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.getValidTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.setValidTo = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * repeated string hotel_codes = 10;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.getHotelCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.setHotelCodesList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.addHotelCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.clearHotelCodesList = function() {
  return this.setHotelCodesList([]);
};


/**
 * optional string kind = 11;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.getKind = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.setKind = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string applies_to = 12;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.getAppliesTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.prototype.setAppliesTo = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.toObject = function(includeInstance, msg) {
  var f, obj = {
    entityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    kind: jspb.Message.getFieldWithDefault(msg, 2, ""),
    agreementId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    lineId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    appliesTo: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey;
  return proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setKind(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgreementId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLineId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppliesTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getKind();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAgreementId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLineId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAppliesTo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string entity_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.prototype.getEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.prototype.setEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string kind = 2;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.prototype.getKind = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.prototype.setKind = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string agreement_id = 3;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.prototype.getAgreementId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.prototype.setAgreementId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string line_id = 4;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.prototype.getLineId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.prototype.setLineId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string applies_to = 5;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.prototype.getAppliesTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey} returns this
 */
proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.prototype.setAppliesTo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: (f = msg.getKey()) && proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.toObject(includeInstance, f),
    commissionPct: jspb.Message.getFieldWithDefault(msg, 2, ""),
    net: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    validFrom: jspb.Message.getFieldWithDefault(msg, 4, ""),
    validTo: jspb.Message.getFieldWithDefault(msg, 5, ""),
    hotelCodesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest;
  return proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey;
      reader.readMessage(value,proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.deserializeBinaryFromReader);
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommissionPct(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNet(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidFrom(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidTo(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addHotelCodes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.serializeBinaryToWriter
    );
  }
  f = message.getCommissionPct();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNet();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getValidFrom();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getValidTo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getHotelCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
};


/**
 * optional CommercialTermsRowKey key = 1;
 * @return {?proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.getKey = function() {
  return /** @type{?proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey, 1));
};


/**
 * @param {?proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey|undefined} value
 * @return {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest} returns this
*/
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.setKey = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest} returns this
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.clearKey = function() {
  return this.setKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.hasKey = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string commission_pct = 2;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.getCommissionPct = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest} returns this
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.setCommissionPct = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool net = 3;
 * @return {boolean}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.getNet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest} returns this
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.setNet = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string valid_from = 4;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.getValidFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest} returns this
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.setValidFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string valid_to = 5;
 * @return {string}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.getValidTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest} returns this
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.setValidTo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated string hotel_codes = 6;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.getHotelCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest} returns this
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.setHotelCodesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest} returns this
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.addHotelCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest} returns this
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowRequest.prototype.clearHotelCodesList = function() {
  return this.setHotelCodesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    row: (f = msg.getRow()) && proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse;
  return proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.b2b.v1.CommercialTermsRow;
      reader.readMessage(value,proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.deserializeBinaryFromReader);
      msg.setRow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRow();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.b2b.v1.CommercialTermsRow.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommercialTermsRow row = 1;
 * @return {?proto.witbooking.backoffice.b2b.v1.CommercialTermsRow}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse.prototype.getRow = function() {
  return /** @type{?proto.witbooking.backoffice.b2b.v1.CommercialTermsRow} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.b2b.v1.CommercialTermsRow, 1));
};


/**
 * @param {?proto.witbooking.backoffice.b2b.v1.CommercialTermsRow|undefined} value
 * @return {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse} returns this
*/
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse.prototype.setRow = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse} returns this
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse.prototype.clearRow = function() {
  return this.setRow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.b2b.v1.UpdateCommercialTermsRowResponse.prototype.hasRow = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: (f = msg.getKey()) && proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest}
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest;
  return proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest}
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey;
      reader.readMessage(value,proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.deserializeBinaryFromReader);
      msg.setKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommercialTermsRowKey key = 1;
 * @return {?proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey}
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest.prototype.getKey = function() {
  return /** @type{?proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey, 1));
};


/**
 * @param {?proto.witbooking.backoffice.b2b.v1.CommercialTermsRowKey|undefined} value
 * @return {!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest} returns this
*/
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest.prototype.setKey = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest} returns this
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest.prototype.clearKey = function() {
  return this.setKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowRequest.prototype.hasKey = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse}
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse;
  return proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse}
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.b2b.v1.DeleteCommercialTermsRowResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.witbooking.backoffice.b2b.v1);
